import { FC } from 'react'
import classNames from 'classnames'
import { Icon } from 'mk-pc'
import './index.scss'

interface BaseFileListProps {
  rowNum?: number
  files: Array<any>
}

/**
 * 文件列表
 * @param props
 * @returns
 */
export const FileList: FC<BaseFileListProps> = (props) => {
  const { rowNum, files = [] } = props

  const className = classNames('attachlist-show', {
    row1: rowNum === 1,
    row2: rowNum === 2,
    row3: rowNum === 3
  })

  return (
    <ul className={className}>
      {files.map((file: any) => (
        <li key={file.filehash} className="attachlist-show__item">
          <span className="file-icon">
            <Icon name="icon-file" size="16" />
          </span>
          <div className="text">
            <p>{file.fileName}</p>
          </div>
        </li>
      ))}
    </ul>
  )
}
